import { render } from "./VulInfoTab.vue?vue&type=template&id=0b3ac7e4"
import script from "./VulInfoTab.vue?vue&type=script&lang=js"
export * from "./VulInfoTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__